module.exports = __webpack_public_path__ + "static/media/056-keyboard.ab7ec519.svg";